// @ts-nocheck
import React from 'react';
import ReactMarkdownLib, { Options } from 'react-markdown';
import gfm from 'remark-gfm';
import raw from 'rehype-raw';
import remarkParse from 'remark-parse';
import markdownComponents from './styles';

const ReactMarkdown: React.FC<React.PropsWithChildren<Options>> = (props) => {
  return (
    <ReactMarkdownLib
      parse={remarkParse}
      remarkPlugins={[gfm]}
      rehypePlugins={[raw]}
      components={markdownComponents}
      {...props}
    />
  );
};

export default ReactMarkdown;
